import styled, { css } from 'styled-components';
import { ModalContent, TextsContainer } from '../../ui/Select/styled';
import { FlexCenterAligned } from '../../../styled/common';
import { Header } from '../../ui/PageHeader/styled';
import { Breakpoints } from '../../../styled/constants';
import { animation } from '../../../styled/placeholders.styled';

export const getPopoverFilterStyles = css`
  height: 50px;
  padding: 15px 14px;
  border-radius: 14px;
  border: 1px solid ${({ theme }) => theme.colors.border.primary};
  box-sizing: border-box;

  ${TextsContainer} {
    width: 100%;
  }

  @media screen and (min-width: ${Breakpoints.tablet}px) {
    padding: 15px;
    width: 217px;
  }
`;

export const modalStyles = css`
  ${ModalContent} {
    padding: 0 15px;
  }

  ${Header} {
    border-bottom: none;
  }
`;

export const SelectedValueContainer = styled(FlexCenterAligned)`
  > svg {
    stroke-width: 0.6;
  }

  font-size: 16px;

  @media screen and (min-width: ${Breakpoints.tablet}px) {
    gap: 3px;
    justify-content: flex-start;
  }

  @media screen and (max-width: ${({ theme }) => theme.tabletBreakpoint}) {
    &,
    span {
      font-size: 0;
    }
  }
`;

export const SortingContainer = styled.div`
  label {
    cursor: pointer;
    padding: 0;
    height: 54px;

    &::after {
      display: none;
    }

    > span {
      font-size: 15px;
    }
  }
`;

export const SortingPlaceholder = styled(SelectedValueContainer)`
  ${animation};
  height: 50px;
  width: 50px;
  border-radius: 14px;

  @media screen and (min-width: ${Breakpoints.tablet}px) {
    width: 217px;
  }
`;
